<template>
	<div class="home">
		<navComponent/>
		<div class="container">
			<div class="row" style="margin-top: 10%">
				<div class="col-sm-6 d-none d-sm-block float-left">
					<div style="margin:5%">
						<img src="../assets/global.svg" alt="" style="width: 90%;">
						<h5 style="margin: 5% 0; text-align: left"><b>Amazing Experience, comes with time. We are improving our self daily.</b></h5>
					</div>
				</div>
				<div class="col-12 col-sm-6 card">
					<div class="container text-center card-body">
						<h2><b>Register</b></h2>
						<br>
						<div v-if="registerUserData.errors.length > 0">
							<div
								v-for="(a,i) in registerUserData.errors"
								:key="i"
								class="alert alert-danger"
							>{{ a }}</div>
						</div>
						<div class="form-group">
							<label for="name"  style="float:left">Name</label>
							<input
								type="text"
								v-model="registerUserData.name"
								class="form-control form-control-sm"
								id="name"
								placeholder="Full Name"
								required
							/>
						</div>
						<div class="form-group">
							<label for="email" style="float:left">Email address</label>
							<input
								type="email"
								v-model="registerUserData.email"
								class="form-control form-control-sm"
								id="email"
								aria-describedby="emailHelp"
								placeholder="Email Address"
								required
							/>
						</div>
						<button type="submit" @click="registerUser" class="btn btn-primary" style="margin-bottom: 20px">Register</button>
						<div class="sign-up">
							Already have account
							<router-link to="/signup" class="text-primary" style="cursor: pointer" data-dismiss="modal"><b>Login</b></router-link>
						</div>
						<h6 style="margin-top: 4%;">
							<span>or</span>
						</h6>
						<button
							@click="socialLogin('google')"
							class="btn btn-block btn-default btn-dark"
							style="display: flex; justify-content: center"
							id="google-signup"
						>
							<img
								alt="Google Logo"
								src="../assets/google-logo.png"
								class="mr-1"
								style="width: 40px;"
							/>
							<span style="font-weight: bold; font-size: 18px; margin-top: 5px;">Sign In with Google</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
  import navComponent from '@/components/nav.vue'
  import firebase from "firebase";
  export default {
    name: 'home',
    data() {
      return {
        registerUserData: {
          email: "",
          name: "",
          errors: []
        },
        forgetPasswordUserEmail:"",
      }
    },
    components: {
      navComponent,
    },
    methods: {
      registerUser(e){
        console.log(this.registerUserData)
        e.preventDefault();
        let $ = this;
        $.registerUserData.errors = [];
        if ($.registerUserData.name === "") {
          $.registerUserData.errors.push("Name is required");
        } else if ($.registerUserData.email === "") {
          $.registerUserData.errors.push("Email is required");
        }
        if ($.registerUserData.email && $.registerUserData.name) {
          $.$store.dispatch("registerUser", $.registerUserData).then(resp => {
            if (resp.data.status === 'success') {
              console.log('Move to verify')
              $.$toast.open({
                message: "Email successfully sent.",
                type: "success",
                position: "top",
                queue: true
              });
              $.$router.push('/verify')
            }else {
              $.$toast.open({
                message: resp.data.data,
                type: "error",
                position: "top",
                queue: true
              });
            }
          })
        }

      },
      submitUserInfo: function() {
        this.$store.dispatch("insertUser", this.userData).then(resp => {
          if (resp.data.status === "success") {
            this.login = true;
            localStorage.setItem("user_info", JSON.stringify(resp.data.data));
            this.$toast.open({
              message: "Login successful, create or join any event.",
              type: "success",
              position: "top",
              queue: true
            });
            this.userData = resp.data.data
            let data = {
              name: this.userData.name,
              email: this.userData.email,
              number: this.userData.phoneNumber,
              photoURL: this.userData.photoURL
            };
            var event_name = "Login Form";
            window.freshsales.trackEvent(event_name, data);
            this.$router.push("/dashboard");
          } else {
            this.$toast.open({
              message: resp.data.data,
              type: "error",
              position: "top",
              queue: true
            });
          }
        });
      },
      socialLogin(provider) {
        let providerAuth = "";
        if (provider === "google") {
          providerAuth = new firebase.auth.GoogleAuthProvider();
        } else if (provider === "twitter") {
          providerAuth = new firebase.auth.TwitterAuthProvider();
        }
        firebase
          .auth()
          .signInWithPopup(providerAuth)
          .then(result => {
            // call an api here to store information in Mongodb Se
            this.userData = {
              name: result.user.displayName,
              email: result.user.email,
              photoURL: result.user.photoURL,
              phoneNumber: result.user.phoneNumber,
              user_type: "audience",
              company: "NA",
              designation: "NA",
              is_admin: false,
              location: "",
              credential: result.credential,
              token: "",
              city: "",
              country: "",
              bio: "Hey, I'm using meetbeans.",
              fb_url: "",
              twitter_url: "",
              linkedin_url: ""
            };
            this.submitUserInfo();
          })
          .catch(err => {
            alert("Oops. " + err.message);
          });
      }
    },
    created() {
      if (localStorage.getItem('user_info')){
        this.$router.push('/')
      }
    }
  }
</script>

<style scoped>
	h6 {
		width: 100%;
		text-align: center;
		border-bottom: 1px solid rgb(87, 81, 81);
		line-height: 0.1em;
		margin: 10px 0 20px;
	}

	h6 span {
		background: #1b1b1b;
		padding: 0 10px;
	}
</style>

